import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useApiTranslations} from '../../../../context/ApiTranslationsContext';
import {FeatureModule} from '../../../../model/license/feature-module';

export type Props = {
  createOrganization: (name: string, publicKey: string) => Promise<void>
  isDrawerOpen: boolean
  onDrawerClosed: () => void
}

export type CreateOrganizationDrawerState = {
  organizationName: string
  setOrganizationName: (value: string) => void
  organizationPublicKey: string
  setOrganizationPublicKey: (value: string) => void

  closeDrawer: () => void
  handleSubmit: () => Promise<void>
  saveButtonDisabled: boolean
  translateLocal: (key: string) => string
  translate: (key: string) => string
}

export const useCreateOrganizationDrawerState = (props: Props): CreateOrganizationDrawerState => {
  const {t} = useTranslation()
  const {translate: apiTranslate} = useApiTranslations()
  const [organizationName, setOrganizationName] = useState('');
  const [organizationPublicKey, setOrganizationPublicKey] = useState('');

  const cleanupState = () => {
    setOrganizationName('');
    setOrganizationPublicKey('');
  }

  const closeDrawer = () => {
    cleanupState()
    props.onDrawerClosed();
  }

  return {
    translate: (key) => apiTranslate(key) || t(key),
    translateLocal: (key) => t(`organizations-page.create-organization-drawer.${key}`),
    organizationName: organizationName,
    setOrganizationName: setOrganizationName,
    organizationPublicKey: organizationPublicKey,
    setOrganizationPublicKey: setOrganizationPublicKey,
    closeDrawer: closeDrawer,
    handleSubmit: async () => {
      await props.createOrganization(organizationName, organizationPublicKey)
      closeDrawer()
    },
    saveButtonDisabled: organizationName === null || organizationName === '' || organizationPublicKey === null || organizationPublicKey === ''
  }
}